// Catalogue filtrable de l'accueil (templates/components/anima/accueil/produits.twig) :
// familles, origines, mois de disponibilité. Une carte reste visible si elle répond à chaque
// filtre actif (OU à l'intérieur d'un filtre, ET entre filtres). Les dix premières cartes
// retenues s'affichent, « Afficher plus de produits » dévoile le reste. L'URL
// (?famille=tomates&origine=maroc) pré-coche les filtres : c'est ainsi qu'arrivent les liens
// du méga-menu « Nos produits ». La recherche du hero sans fiche unique arrive avec ?q=… : seules
// les cartes dont les mots-clés (data-recherche) contiennent tous les mots restent, avec un
// bandeau ; si aucune ne correspond, tout le catalogue et une demande d'offre.

const VISIBLES_PAR_DEFAUT = 10
const MOT_MIN = 2 // lettres : les mots plus courts sont ignorés, comme côté serveur
// Même règle que Produits::normaliser() : minuscules, sans accents, sans mots vides, « s » final retiré.
const MOTS_VIDES = ['de', 'du', 'des', 'la', 'le', 'les', 'en', 'et', 'au', 'aux', 'un', 'une', 'pour']
const normaliser = (texte) => texte.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  .split(/[^a-z0-9]+/)
  .filter((m) => m.length >= MOT_MIN && !MOTS_VIDES.includes(m))
  .map((m) => m.replace(/s+$/, '') || m)
const FADE_DURATION = 260 // ms, grille atténuée pendant le filtrage (maquette « 30 sept »)

const init = (root) => {
  const grid = root.querySelector('[data-anima-grille]')
  const cards = [...grid.children]
  const more = root.querySelector('[data-anima-plus]')
  const empty = root.querySelector('[data-anima-vide]')
  const visibles = parseInt(root.dataset.visibles, 10) || VISIBLES_PAR_DEFAUT
  const filtres = [...root.querySelectorAll('[data-anima-filtre]')]
  const requete = root.querySelector('[data-anima-requete]')
  let expanded = false
  let mots = []

  const actifs = () => Object.fromEntries(filtres.map((f) => [
    f.dataset.animaFiltre,
    [...f.querySelectorAll('input:checked')].map((i) => i.value)
  ]))

  // Chaque mot cherché commence un mot-clé de la carte (même règle que Produits::correspond()).
  const trouvees = () => cards.filter((card) => {
    const debuts = (card.dataset.recherche || '').split(/[ |]+/)
    return mots.every((m) => debuts.some((d) => d.startsWith(m)))
  })

  const apply = () => {
    const a = actifs()
    const parTexte = mots.length ? trouvees() : []
    const base = parTexte.length ? parTexte : cards
    const retenues = base.filter((card) => Object.entries(a).every(([cle, vals]) => {
      if (!vals.length) {
        return true
      }
      const own = (card.dataset[cle] || '').split(' ')
      return vals.some((v) => own.includes(v))
    }))
    cards.forEach((card) => {
      const rang = retenues.indexOf(card)
      card.hidden = rang === -1 || !expanded && rang >= visibles
    })
    more.hidden = expanded || retenues.length <= visibles
    empty.hidden = retenues.length > 0
    filtres.forEach((f) => {
      const n = a[f.dataset.animaFiltre].length
      const badge = f.querySelector('.anima-filtre-count')
      badge.hidden = !n
      badge.textContent = n
    })
  }

  let fadeTimer = 0
  const fade = () => {
    grid.classList.add('is-filtering')
    clearTimeout(fadeTimer)
    fadeTimer = setTimeout(() => grid.classList.remove('is-filtering'), FADE_DURATION)
  }

  const closeAll = (except) => filtres.forEach((f) => {
    if (f !== except) {
      f.querySelector('.anima-filtre-menu').hidden = true
      f.querySelector('.anima-filtre-btn').setAttribute('aria-expanded', 'false')
    }
  })

  filtres.forEach((f) => {
    const btn = f.querySelector('.anima-filtre-btn')
    const menu = f.querySelector('.anima-filtre-menu')
    btn.addEventListener('click', () => {
      const open = menu.hidden
      closeAll(f)
      menu.hidden = !open
      btn.setAttribute('aria-expanded', open ? 'true' : 'false')
    })
    menu.addEventListener('change', () => {
      fade()
      apply()
    })
    // Préréglages de saison du filtre Disponibilité : cochent exactement les mois de la saison.
    menu.querySelectorAll('[data-anima-saison]').forEach((b) => {
      b.addEventListener('click', () => {
        const mois = b.dataset.animaSaison.split(' ').filter(Boolean)
        menu.querySelectorAll('input').forEach((i) => {
          i.checked = mois.includes(i.value)
        })
        fade()
        apply()
      })
    })
  })
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-anima-filtre]')) {
      closeAll()
    }
  })
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAll()
    }
  })
  more.addEventListener('click', () => {
    expanded = true
    apply()
  })

  // Recherche du hero (?q=…) : bandeau, nombre de produits trouvés, retour au catalogue entier.
  const params = new URLSearchParams(window.location.search)
  const q = (params.get('q') || '').trim()
  mots = normaliser(q)
  if (requete && mots.length) {
    const n = trouvees().length
    let modele = requete.dataset.aucun
    if (n) {
      modele = n === 1 ? requete.dataset.un : requete.dataset.plusieurs
    }
    requete.querySelector('[data-anima-requete-txt]').textContent = modele.replace('%d', n).replace('%s', q)
    requete.querySelector('[data-anima-requete-offre]').hidden = n > 0
    requete.querySelector('[data-anima-requete-effacer]').hidden = n === 0
    requete.hidden = false
    requete.querySelector('[data-anima-requete-effacer]').addEventListener('click', () => {
      mots = []
      requete.hidden = true
      params.delete('q')
      const reste = params.toString()
      window.history.replaceState(null, '', window.location.pathname + (reste ? `?${reste}` : '') + window.location.hash)
      fade()
      apply()
    })
  }

  // Pré-sélection des filtres par l'URL.
  filtres.forEach((f) => {
    params.getAll(f.dataset.param).forEach((v) => {
      const input = f.querySelector(`input[value="${CSS.escape(v)}"]`)
      if (input) {
        input.checked = true
      }
    })
  })

  apply()
}

const boot = () => document.querySelectorAll('[data-anima-catalogue]').forEach(init)

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
